import { useCallback, useRef } from 'react'
import { usePersistedState, objectDiff } from '@iqueue/ui-kit'
import { pathOr, path } from 'ramda'

const defaultLocale = 'ru'
// const locale = new Intl.Locale(navigator.language)
const locale = new Intl.Locale(defaultLocale)
// const globalLocale = locale.language + (locale.script ? '-' + locale.script : '')
const globalLocale = locale.language + (locale.script ? '-' + locale.script : '')
const translations = {}

function safePathScope(path = '') {
  return Array.isArray(path) ? path : path.split('.')
}

function findScopedTranslation(locale, scope, subPath, lastScope) {
  const fullPath = !!scope ?
    [locale, ...safePathScope(scope), ...safePathScope(subPath)] :
    [locale, ...safePathScope(subPath)]

  const value = path(fullPath, translations)

  if (!value && !!scope) {
    return findScopedTranslation(locale, undefined, subPath, scope)
  }

  if (!value && locale !== defaultLocale) {
    return findScopedTranslation(defaultLocale, scope || lastScope, subPath)
  }

  return {
    value,
    fullPath,
  }
}

export function t(key, { scope, ...args } = {}) {
  const val = window.localStorage.getItem('language')
  const locale = !!val ? JSON.parse(val) : globalLocale

  let { value, fullPath } = findScopedTranslation(locale, scope, key)

  if (!value) {
    console.warn(
      'Translation for scope',
      `"${ safePathScope(scope).join('.') }"`,
      'and path',
      `"${ safePathScope(key).join('.') }"`,
      `was not found for locale "${ locale }"!`,
    )

    value = fullPath.join('.')
  }

  return value.replace(/\${([^}]*)}/g, (_, g) => args[g] === undefined ? g : args[g])
}

/**
 * @returns {{
 *   locale: ((value: (((prevState: string) => string) | string)) => void) | string,
 *   setLocale: ((function(*): void)|*)
 * }}
 */
export default function useTranslate() {
  const [locale, setLocale] = usePersistedState('language', globalLocale)

  // const handleSetLocale = useCallback((locale) => {
  //   // TODO convert old locale formats to current
  //   // TODO check for locale exists
  //   setLocale(locale)
  // }, [])

  return {
    locale: locale + '',
    setLocale,
  }
}

export function appendLocaleSources(sources, locale = globalLocale) {
  if (!translations[locale]) {
    translations[locale] = {}
  }

  for (const key in sources) {
    translations[locale][key] = sources[key]
  }
}

export function debugPrintLocaleSources(locale, scope = '') {
  const out = locale ? pathOr({}, [locale, ...scope.split('.')], translations) : translations
  // console.table(Object.entries(out).map(([key, value]) => ({ Key: key, Value: value })))
}

export function debugPrintLocalesDiff(localeA, localeB, scope = '') {
  const out = objectDiff(translations[localeA] || {}, translations[localeB] || {})
  // console.table(Object.entries(out).map(([key, value]) => ({ Key: key, Difference: value })))
}
